import React, { useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../../../stores/authStore';
import styles from './ChangePasswordForm.module.css';

/**
 * ChangePasswordForm Component
 * 비밀번호 변경 폼 컴포넌트
 */
const ChangePasswordForm = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // 로그인 화면에서 전달받은 사업자번호 (비밀번호 미설정 시)
  const passedBusinessNumber = location.state?.businessNumber;

  const pharmacy = useAuthStore(state => state.pharmacy);
  const setPasswordAction = useAuthStore(state => state.setPassword);
  const setIsDefaultPassword = useAuthStore(state => state.setIsDefaultPassword);
  const isLoading = useAuthStore(state => state.isLoading);
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  // 인증되지 않고, 전달받은 사업자번호도 없는 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated() && !passedBusinessNumber) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    // 유효성 검사
    if (password.length < 6) {
      setError('비밀번호는 6자 이상이어야 합니다.');
      return;
    }

    if (password !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      // 로그인된 경우 pharmacy에서, 아니면 전달받은 사업자번호 사용
      const businessNumber =
        pharmacy?.business_registration_number || passedBusinessNumber;

      if (!businessNumber) {
        setError('사업자등록번호 정보가 없습니다. 다시 로그인해주세요.');
        return;
      }

      const result = await setPasswordAction(
        businessNumber,
        password,
        passwordConfirm,
        currentPassword
      );

      if (result.success) {
        // 로그인된 경우 대시보드로, 아니면 로그인 페이지로
        alert(isAuthenticated() ? '비밀번호가 변경되었습니다.' : '비밀번호가 설정되었습니다. 다시 로그인해주세요.');
        if (isAuthenticated()) {
          navigate('/dashboard/home');
        } else {
          navigate('/login');
        }
      } else {
        setError(result.error || '비밀번호 변경에 실패했습니다.');
      }
    } catch (err) {
      setError('비밀번호 변경 중 오류가 발생했습니다.');
    }
  };

  const handleSkip = () => {
    // 로그인된 경우만 스킵 가능 (대시보드로 이동)
    if (isAuthenticated()) {
      setIsDefaultPassword(false);
      navigate('/dashboard/home');
    } else {
      // 비로그인 상태에서는 로그인 페이지로
      navigate('/login');
    }
  };

  // 초기 비밀번호 설정인지 여부
  const isInitialSetup = !isAuthenticated() && passedBusinessNumber;

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2>{isInitialSetup ? '비밀번호 설정' : '비밀번호 변경'}</h2>

        <p className={styles.description}>
          {isInitialSetup
            ? '최초 로그인을 위해 비밀번호를 설정해주세요.'
            : '보안을 위해 새로운 비밀번호를 설정해주세요.'}
        </p>

        {error && <div className={styles.error}>{error}</div>}

        {/* 비밀번호 변경 시 현재 비밀번호 필수 (백엔드 10/22). 처음 설정은 운영팀 요청이라 서버가 403 문구를 준다 */}
        {!isInitialSetup && (
          <input
            type="password"
            placeholder="현재 비밀번호"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            required
          />
        )}

        <input
          type="password"
          placeholder="새 비밀번호 (6자 이상)"
          value={password}
          onChange={e => setPassword(e.target.value)}
          minLength={6}
          required
        />

        <input
          type="password"
          placeholder="비밀번호 확인"
          value={passwordConfirm}
          onChange={e => setPasswordConfirm(e.target.value)}
          minLength={6}
          required
        />

        <button type="submit" disabled={isLoading}>
          {isLoading
            ? isInitialSetup
              ? '설정 중...'
              : '변경 중...'
            : isInitialSetup
              ? '비밀번호 설정'
              : '비밀번호 변경'}
        </button>

        {!isInitialSetup && (
          <span className={styles.skipLink} onClick={handleSkip}>
            다음에 변경
          </span>
        )}
      </form>
    </div>
  );
};

export default ChangePasswordForm;
